"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const config_1 = require("config");
const formatISODate_1 = __importDefault(require("./formatISODate"));
const parseUSDayMonthYearDate_1 = __importDefault(require("./parseUSDayMonthYearDate"));
const formatISODateString = (dateString) => {
    if ((0, lodash_1.isEmpty)(dateString))
        return dateString;
    if (dateString.length !== config_1.DATE_STRING_LENGTH)
        return dateString;
    return (0, formatISODate_1.default)((0, parseUSDayMonthYearDate_1.default)(dateString));
};
exports.default = formatISODateString;
